import { Badge } from '@gto/ui/badge'
import { cn } from '@gto/ui/cn'
import { Typography } from '@gto/ui/typography'

import { flattenPayoutDetails, methodLabel } from '@/domain/payout-methods'

type PayoutMethodSummaryProps = {
  method: string
  details: Record<string, unknown>
  className?: string
}

/**
 * Itemised read view of a partner's stored payout details: a method badge plus
 * label/value rows. Tolerant of both the new structured shape (expands the
 * nested address) and the legacy free-form dicts.
 */
export const PayoutMethodSummary = ({ method, details, className }: PayoutMethodSummaryProps) => {
  const rows = flattenPayoutDetails(details)

  return (
    <div className={cn('flex flex-col gap-3', className)}>
      <Badge color="secondary">{methodLabel(method)}</Badge>
      {rows.length > 0 && (
        <div className="flex flex-col gap-2">
          {rows.map((row) => (
            <div
              key={row.label}
              className="flex items-baseline justify-between gap-4"
            >
              <Typography
                color="text.secondary"
                variant="caption"
              >
                {row.label}
              </Typography>
              <Typography
                className="break-all text-right font-medium"
                variant="body2"
              >
                {row.value}
              </Typography>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
